module.exports = __webpack_public_path__ + "static/media/adela.4ef26bde.png";